import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { stateAbbreviations, formatDate } from '../../../common/utils';
import { createOffer } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';


const AddOffer = ( { close, aid, uid, l, pStatus, qStatus, rStatus } ) => {
    const [ name, setName ] = useState();
    const [ offerDate, setOfferDate ] = useState();
    const [ status, setStatus ] = useState();
    const [ ready, setReady ] = useState( false );
    const [ addr, setAddr ] = useState();
    const [ city, setCity ] = useState();
    const [ state, setState ] = useState();
    const [ zip, setZip ] = useState();
    const [ price, setPrice ] = useState();
    const [ loan, setLoan ] = useState();
    const [ rate, setRate ] = useState();
    const [ mc, setMC ] = useState();
    const [ offerType, setOfferType ] = useState();
    const [ processing, setProcessing ] = useState( false );
    
    useEffect( () => {
        const today = new Date();
        setOfferDate( formatDate( today ) );
    }, [] );

    useEffect( () => {
        if ( [ 'refi', 'quote' ].includes( offerType ) && rate && rate.length > 0 ) {
            setReady( true );
        } else if ( loan ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ offerType, loan, rate ] );

    useEffect( () => {
        switch ( offerType ) {
            case 'refi':
                setStatus( rStatus.find( p => p.default ).value );
                break;

            case 'purchase':
                setStatus( pStatus.find( p => p.default ).value );
                break;

            case 'quote':
                setStatus( qStatus.find( p => p.default ).value );
                break;

            default:
                console.log( 'unknown offerType: ' + offerType );
        }
    }, [ pStatus, rStatus, qStatus, offerType ] );

    const create = async () => {
        setProcessing( true );

        const offer = {
            name: name,
            offerDate: offerDate,
            status: status,
            subjectAddress: addr,
            subjectCity: city,
            subjectState: state,
            subjectZip: zip,
            price: price,
            amount: loan,
            rate: rate,
            mc: mc,
            type: offerType,
            lid: l.details.lid
        };

        console.log( 'offer: ', offer );
        const added = await createOffer( aid, uid, offer );
        if ( added.length ) {
            toast.success( `The Offer has been recorded`, { theme: 'dark' } );
            setProcessing( false );
            close();
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New Offer</Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Form.Group>
                            <Form.Label>This is to track...</Form.Label>
                            <Row>
                                <Col xs='auto'>
                                    {
                                        ( l.details?.purpose?.match( /refi/i ) ) ? (
                                            <Form.Check inline label="A refi offer" name='offerType' type='radio' id='Refinance' onChange={ ( e ) => setOfferType( 'refi' ) } />
                                        ) : (
                                            <Form.Check inline label="An offer on a property" name='offerType' type='radio' id='Purchase' onChange={ ( e ) => setOfferType( 'purchase' ) } />
                                        )
                                    }
                                </Col>
                                <Col xs='auto'>
                                    <Form.Check inline label='A rate quote' name='offerType' type='radio' id='Quote' onChange={ ( e ) => setOfferType( 'quote' ) } />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                {
                    ( offerType === 'quote' ) ? (
                        <Container fluid>
                            <Row className='pt-3 pb-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Quote Date</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='date' id='offerDate' value={offerDate} onChange={ ( e ) => setOfferDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Loan Amount</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={loan} onChange={ ( e ) => setLoan( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Rate Quoted</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={rate} onChange={ ( e ) => setRate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>MC URL</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={mc} onChange={ ( e ) => setMC( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Container>
                    ) : ( offerType === 'purchase' ) ? (
                        <Container fluid>
                            <Row className='pt-3 pb-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Offer Date</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='date' id='offerDate' value={offerDate} onChange={ ( e ) => setOfferDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Current Status</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                            {
                                                pStatus.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Purchase Price</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='price' value={price} onChange={ ( e ) => setPrice( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Loan Amount</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={loan} onChange={ ( e ) => setLoan( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Rate Quoted</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={rate} onChange={ ( e ) => setRate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Street</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-street' value={addr} onChange={ ( e ) => setAddr( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>City</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-city' value={city} onChange={ ( e ) => setCity( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>State</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={state} onChange={ ( e ) => setState( e.target.value ) }>
                                            {
                                                stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col style={ { maxWidth: '100px' } }>
                                    <Form.Group>
                                        <Form.Label>Zip</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-zip' value={zip} onChange={ ( e ) => setZip( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>MC URL</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={mc} onChange={ ( e ) => setMC( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Container>
                    ) : ( offerType === 'refi' ) ? (
                        <Container fluid>
                            <Row className='pt-3 pb-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Presented Date</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='date' id='offerDate' value={offerDate} onChange={ ( e ) => setOfferDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Current Status</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                            {
                                                rStatus.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Est. Property Value</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='price' value={price} onChange={ ( e ) => setPrice( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Loan Amount</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={loan} onChange={ ( e ) => setLoan( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Rate Quoted</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={rate} onChange={ ( e ) => setRate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Street</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-street' value={addr} onChange={ ( e ) => setAddr( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>City</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-city' value={city} onChange={ ( e ) => setCity( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>State</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={state} onChange={ ( e ) => setState( e.target.value ) }>
                                            {
                                                stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col style={ { maxWidth: '100px' } }>
                                    <Form.Group>
                                        <Form.Label>Zip</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-zip' value={zip} onChange={ ( e ) => setZip( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>MC URL</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type='text' id='loan' value={mc} onChange={ ( e ) => setMC( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Container>
                    ) : (
                        null
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    pStatus: state.user.meta.offer.picklist.purchStatus,
    qStatus: state.user.meta.offer.picklist.quoteStatus,
    rStatus: state.user.meta.offer.picklist.refiStatus
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( AddOffer );